var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-263 355 84 83",
    enableBackground: "new -263 355 84 83",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    transform: "translate(0.054)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -263.1,
    y: 355,
    width: 84,
    height: 83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    transform: "translate(0 0)",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fill: "#FDD44C",
    d: "M-262.3,396.5c0-32.2,9-41.2,41.2-41.2s41.2,9,41.2,41.2s-9,41.2-41.2,41.2 S-262.3,428.7-262.3,396.5"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -235,
    y: 373,
    width: 29.5,
    height: 49.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M-208.9,373h-22.7c-1.9,0.1-3.5,1.7-3.4,3.6v41.8c-0.1,1.9,1.5,3.6,3.4,3.6h22.7c1.9-0.1,3.5-1.7,3.4-3.6 v-41.8C-205.4,374.7-207,373.1-208.9,373z M-225.1,375.2h9.8c0.2,0,0.3,0.2,0.3,0.5c0,0.3-0.2,0.5-0.3,0.5h-9.8 c-0.2,0-0.3-0.2-0.3-0.5C-225.5,375.5-225.3,375.2-225.1,375.2 M-216.3,419.7h-7.9c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 h7.9c0.7,0,1.3,0.6,1.3,1.3C-215,419.2-215.6,419.7-216.3,419.7 M-208.4,414.8h-23.8v-36.3h23.8L-208.4,414.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNo);
export default __webpack_public_path__ + "static/media/new-no.6e56364bd0b628f08860821a1af9ec27.svg";
export { ForwardRef as ReactComponent };